<!-- ui-fallback: mat-menu (what bz-menu is built on, same panel look) because the items carry icons and bz-menu items are label-only. -->
<bz-button variant="tertiary" size="fit"
           appBringozIdGenerator="threepl-service-actions-trigger"
           [matMenuTriggerFor]="menu"
           [ariaLabel]="'Delivery Actions' | translate"
           (click)="onTriggerClick($event)">
  <bz-icon class="threepl-service-actions-trigger-icon" [icon]="icons.menu"></bz-icon>
</bz-button>

<mat-menu #menu="matMenu" class="threepl-service-actions-menu">
  <!-- ui-fallback: mat-menu item, see above. -->
  <button mat-menu-item type="button" appBringozIdGenerator="threepl-service-actions-addNote" (click)="onSelected('addNote')">
    <bz-icon matMenuItemIcon size="xl" [icon]="icons.addNote"></bz-icon>
    <span>{{ 'Add Note' | translate }}</span>
  </button>
  <!-- ui-fallback: mat-menu item, see above. -->
  <button mat-menu-item type="button" appBringozIdGenerator="threepl-service-actions-moveToInternal" (click)="onSelected('moveToInternal')">
    <bz-icon matMenuItemIcon size="xl" [icon]="icons.moveToInternal"></bz-icon>
    <span>{{ 'Move To Internal Dispatch' | translate }}</span>
  </button>
  <!-- ui-fallback: mat-menu item, see above. -->
  <button mat-menu-item type="button" appBringozIdGenerator="threepl-service-actions-cancel" (click)="onSelected('cancel')">
    <bz-icon matMenuItemIcon size="xl" [icon]="icons.cancel"></bz-icon>
    <span>{{ 'Cancel' | translate }}</span>
  </button>
</mat-menu>
